(() => {
  const style = document.createElement('style');
  style.textContent = `
    .hg-main-photo[data-boom-gallery] { position:relative; touch-action:pan-y pinch-zoom; cursor:grab; }
    .hg-main-photo[data-boom-gallery] > img { user-select:none; -webkit-user-select:none; -webkit-user-drag:none; }
    .hg-main-photo[data-boom-gallery]:focus-visible { outline:3px solid #B44318; outline-offset:3px; }
    .boom-gallery-arrow { position:absolute; top:50%; transform:translateY(-50%); width:44px; height:44px; border:1px solid #d4c7b7; border-radius:50%; background:#fffcf6; color:#292524; display:grid; place-items:center; padding:0; cursor:pointer; box-shadow:0 2px 8px #29252418; }
    .boom-gallery-arrow:hover { background:#fff3d9; }
    .boom-gallery-arrow:focus-visible { outline:3px solid #B44318; outline-offset:2px; }
    .boom-gallery-arrow[data-direction="-1"] { left:12px; }
    .boom-gallery-arrow[data-direction="1"] { right:12px; }
    .boom-gallery-arrow svg { width:22px; height:22px; pointer-events:none; }
    .boom-gallery-count { position:absolute; bottom:12px; right:12px; background:#fffcf6; color:#292524; border-radius:20px; padding:5px 11px; font-size:13px; line-height:1.5; pointer-events:none; }
  `;
  document.head.appendChild(style);

  function init(scope = document) {
    scope.querySelectorAll('.hg-gallery').forEach(gallery => {
      const viewport = gallery.querySelector('.hg-main-photo');
      const image = gallery.querySelector('[data-hg-main-image]');
      const thumbnails = [...gallery.querySelectorAll('[data-hg-gallery-src]')];
      if (!viewport || !image || thumbnails.length < 2 || viewport.dataset.boomGallery) return;
      viewport.dataset.boomGallery = 'true';
      viewport.tabIndex = 0;
      viewport.setAttribute('role', 'region');
      viewport.setAttribute('aria-label', 'Product photos. Swipe or use left and right arrow keys.');
      image.draggable = false;
      const counter = document.createElement('span');
      counter.className = 'boom-gallery-count';
      counter.setAttribute('role', 'status');
      counter.setAttribute('aria-live', 'polite');
      counter.setAttribute('aria-atomic', 'true');
      const current = () => Math.max(0, thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
      const drawCount = () => {
        counter.textContent = `${current() + 1} / ${thumbnails.length}`;
        counter.setAttribute('aria-label', `Photo ${current() + 1} of ${thumbnails.length}`);
      };
      const select = index => {
        const button = thumbnails[(index + thumbnails.length) % thumbnails.length];
        image.src = button.dataset.hgGallerySrc;
        image.alt = button.querySelector('img')?.alt || button.getAttribute('aria-label') || 'Product photo';
        thumbnails.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        drawCount();
      };
      thumbnails.forEach((button, index) => button.addEventListener('click', () => select(index)));
      [-1, 1].forEach(direction => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'boom-gallery-arrow';
        button.dataset.direction = String(direction);
        button.setAttribute('aria-label', direction < 0 ? 'Previous product photo' : 'Next product photo');
        button.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="${direction < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7'}"/></svg>`;
        button.addEventListener('click', () => select(current() + direction));
        viewport.appendChild(button);
      });
      viewport.appendChild(counter);
      drawCount();
      viewport.addEventListener('keydown', event => {
        if (event.target !== viewport || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        select(current() + (event.key === 'ArrowLeft' ? -1 : 1));
      });
      let gesture = null;
      viewport.addEventListener('pointerdown', event => {
        if (!event.isPrimary) { gesture = null; return; }
        if (event.button !== 0 || event.target.closest('button')) return;
        gesture = { id:event.pointerId, x:event.clientX, y:event.clientY };
        viewport.setPointerCapture(event.pointerId);
      });
      viewport.addEventListener('pointermove', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = Math.abs(event.clientX - gesture.x);
        const dy = Math.abs(event.clientY - gesture.y);
        if (dy > 12 && dy > dx) gesture = null;
      });
      viewport.addEventListener('pointerup', event => {
        if (!gesture || gesture.id !== event.pointerId) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture = null;
        if (Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.25) select(current() + (dx < 0 ? 1 : -1));
      });
      viewport.addEventListener('pointercancel', () => { gesture = null; });
      viewport.addEventListener('lostpointercapture', () => { gesture = null; });
      viewport.addEventListener('dragstart', event => event.preventDefault());
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
